import axios from "axios";

export default function authConfirm(code) {
  return axios.get("/auth-confirm", {
    params: {
      code,
    },
  });
}
